export default {
    atf: {
        name: "ATF",
        url: "nfpa_emergency_operations_symbology/atf",
    },
    biological_sensor: {
        name: "Biological Sensor",
        url: "nfpa_emergency_operations_symbology/biological_sensor",
    },
    border_patrol: {
        name: "Border Patrol",
        url: "nfpa_emergency_operations_symbology/border_patrol",
    },
    chemical_sensor: {
        name: "Chemical Sensor",
        url: "nfpa_emergency_operations_symbology/chemical_sensor",
    },
    customs_service: {
        name: "Customs Service",
        url: "nfpa_emergency_operations_symbology/customs_service",
    },
    dea: {
        name: "DEA",
        url: "nfpa_emergency_operations_symbology/dea",
    },
    doj: {
        name: "DOJ",
        url: "nfpa_emergency_operations_symbology/doj",
    },
    emergency_collection: {
        name: "Emergency Collection",
        url: "nfpa_emergency_operations_symbology/emergency_collection",
    },
    emergency_food_distribution_centers: {
        name: "Emergency Food Distribution Centers",
        url: "nfpa_emergency_operations_symbology/emergency_food_distribution_centers",
    },
    emergency_incident_command_center: {
        name: "Emergency Incident Command Center",
        url: "nfpa_emergency_operations_symbology/emergency_incident_command_center",
    },
    emergency_medical_operation: {
        name: "Emergency Medical Operation",
        url: "nfpa_emergency_operations_symbology/emergency_medical_operation",
    },
    emergency_operation: {
        name: "Emergency Operation",
        url: "nfpa_emergency_operations_symbology/emergency_operation",
    },
    emergency_operations_center: {
        name: "Emergency Operations Center",
        url: "nfpa_emergency_operations_symbology/emergency_operations_center",
    },
    emergency_public_information_center: {
        name: "Emergency Public Information Center",
        url: "nfpa_emergency_operations_symbology/emergency_public_information_center",
    },
    emergency_public_service_center: {
        name: "Emergency Public Service Center",
        url: "nfpa_emergency_operations_symbology/emergency_public_service_center",
    },
    emergency_shelter: {
        name: "Emergency Shelter",
        url: "nfpa_emergency_operations_symbology/emergency_shelter",
    },
    emergency_staging_areas: {
        name: "Emergency Staging Areas",
        url: "nfpa_emergency_operations_symbology/emergency_staging_areas",
    },
    emergency_teams: {
        name: "Emergency Teams",
        url: "nfpa_emergency_operations_symbology/emergency_teams",
    },
    emergency_water_distribution_center: {
        name: "Emergency Water Distribution Center",
        url: "nfpa_emergency_operations_symbology/emergency_water_distribution_center",
    },
    emt_station_locations: {
        name: "Emt Station Locations",
        url: "nfpa_emergency_operations_symbology/emt_station_locations",
    },
    fbi: {
        name: "FBI",
        url: "nfpa_emergency_operations_symbology/fbi",
    },
    fire_suppression_operation: {
        name: "Fire Suppression Operation",
        url: "nfpa_emergency_operations_symbology/fire_suppression_operation",
    },
    fire_hydrant: {
        name: "Fire Hydrant",
        url: "nfpa_emergency_operations_symbology/fire_hydrant",
    },
    fire_station: {
        name: "Fire Station",
        url: "nfpa_emergency_operations_symbology/fire_station",
    },
    health_department_facility: {
        name: "Health Department Facility",
        url: "nfpa_emergency_operations_symbology/health_department_facility",
    },
    hospital: {
        name: "Hospital",
        url: "nfpa_emergency_operations_symbology/hospital",
    },
    hospital_ship: {
        name: "Hospital Ship",
        url: "nfpa_emergency_operations_symbology/hospital_ship",
    },
    intrusion_sensor: {
        name: "Intrusion Sensor",
        url: "nfpa_emergency_operations_symbology/intrusion_sensor",
    },
    law_enforcement_operation: {
        name: "Law Enforcement Operation",
        url: "nfpa_emergency_operations_symbology/law_enforcement_operation",
    },
    medical_evacuation_helicopter_station: {
        name: "Medical Evacuation Helicopter Station",
        url: "nfpa_emergency_operations_symbology/medical_evacuation_helicopter_station",
    },
    medical_facilities_outpatient: {
        name: "Medical Facilities Outpatient",
        url: "nfpa_emergency_operations_symbology/medical_facilities_outpatient",
    },
    morgue: {
        name: "Morgue",
        url: "nfpa_emergency_operations_symbology/morgue",
    },
    nuclear_sensor: {
        name: "Nuclear Sensor",
        url: "nfpa_emergency_operations_symbology/nuclear_sensor",
    },
    operations_frame_symbol: {
        name: "Operations Frame Symbol",
        url: "nfpa_emergency_operations_symbology/operations_frame_symbol",
    },
    other_water_supply_location: {
        name: "Other Water Supply Location",
        url: "nfpa_emergency_operations_symbology/other_water_supply_location",
    },
    police: {
        name: "Police",
        url: "nfpa_emergency_operations_symbology/police",
    },
    prison: {
        name: "Prison",
        url: "nfpa_emergency_operations_symbology/prison",
    },
    radiological_sensor: {
        name: "Radiological Sensor",
        url: "nfpa_emergency_operations_symbology/radiological_sensor",
    },
    secret_service: {
        name: "Secret Service",
        url: "nfpa_emergency_operations_symbology/secret_service",
    },
    sensor_operation: {
        name: "Sensor Operation",
        url: "nfpa_emergency_operations_symbology/sensor_operation",
    },
    tsa: {
        name: "TSA",
        url: "nfpa_emergency_operations_symbology/tsa",
    },
    triage: {
        name: "Triage",
        url: "nfpa_emergency_operations_symbology/triage",
    },
    us_coast_guard: {
        name: "US Coast Guard",
        url: "nfpa_emergency_operations_symbology/us_coast_guard",
    },
    us_marshals_service: {
        name: "US Marshals Service",
        url: "nfpa_emergency_operations_symbology/us_marshals_service",
    },
}
